import React from "react"
import { Button, Form, Input, Modal, Select } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useForm } from "antd/es/form/Form";
import * as SERVICE from "../../constants/service.types";
import { socketEmitEvent } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";

const SendEmailPopup = ({ visible, emails = [], onCancel }) => {
  const { namespace } = useSelector((state) => state);
  const options = emails.map(email => ({
    label: email.email,
    value: email.email
  }))

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [form] = useForm();

  const onFinish = (value) => {
    let data = {
      namespace,
      emails: value?.emails?.join(';') ?? '',
      emailTitle: value?.emailTitle ?? '',
      emailContent: value?.emailContent ?? '',
    };
    let dataObj = {
      appServiceType: SERVICE.SEND_EMAIL_NOTIFICATION,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    }
    dispatch(socketEmitEvent(dataObj));
    onCancel();
  }

  return (
    <Modal
      visible={visible}
      title={t('Email the person in charge')}
      onCancel={() => onCancel()}
      footer={null}
      centered
      width="50%"
      getContainer={() => document.getElementById('main-live-page')}
    >
      <Form
        form={form}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        onFinish={(value) => onFinish(value)}
      >
        <Form.Item
          name="emailTitle"
          label={t('Title')}
          rules={[
            {
              required: true,
              message: t('Please input the title!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="emails"
          label={t('Email')}
          rules={[
            {
              required: true,
              message: t('Please input the email!'),
            }
          ]}
        >
          <Select
            mode="tags"
            style={{ width: '100%' }}
            placeholder={t('Select or enter an email')}
            options={options || []}
          />
        </Form.Item>
        <Form.Item
          label={t('Content')}
          name="emailContent"
        >
          <Input.TextArea />
        </Form.Item>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button style={{ marginRight: "8px" }} onClick={onCancel}>{t('Cancel')}</Button>
          <Form.Item shouldUpdate={true}>
            {() => (
              <Button
                icon={<SaveOutlined />}
                htmlType="submit"
                type="primary"
                disabled={
                  !form.isFieldsTouched(true) ||
                  form.getFieldsError().filter(({ errors }) => errors.length)
                    .length
                }
              >
                {t('Send')}
              </Button>
            )}
          </Form.Item>
        </div>
      </Form>
    </Modal>
  )
}

export default SendEmailPopup;